// Third-party imports
import React from 'react';
import { Title, SimpleForm, SelectInput, SaveButton, useStore } from 'react-admin';
import { Box, Typography } from '@mui/material';

// Local imports - types
import type { Partner } from '@src/types';

const PartnerSelect = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentPartner, setCurrentPartner] = useStore<Partner | null>('currentPartner', null);

  // Get partners from sessionStorage
  let partners: Partner[] = [];
  try {
    const partnersData = sessionStorage.getItem('partners');
    if (partnersData) {
      partners = JSON.parse(partnersData);
    }
  } catch (error) {
    console.error('Failed to parse partners from sessionStorage:', error);
  }

  const handleSubmit = (data: { partnerId: Partner['id'] }) => {
    const selectedPartner = partners.find(p => p.id === data.partnerId);
    if (selectedPartner) {
      setCurrentPartner(selectedPartner);
      // Store selected partner in sessionStorage for canAccess method
      sessionStorage.setItem('selectedPartner', JSON.stringify(selectedPartner));

      // Force a full page reload to clear all cached data and state when switching partners
      window.location.href = '/';
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: 'background.default',
      }}
    >
      <Box sx={{ maxWidth: 600, margin: 'auto', marginTop: '3rem' }}>
        <Title title="Select Partner" />

        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Select Partner
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Choose a partner to continue to the Trove Partner Dashboard
          </Typography>
        </Box>

        {partners.length === 0 ? (
          <Typography variant="body2" color="text.secondary" textAlign="center">
            No partners found. Please contact your administrator.
          </Typography>
        ) : (
          <SimpleForm
            onSubmit={handleSubmit}
            toolbar={
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <SaveButton label="Continue" />
              </Box>
            }
          >
            <SelectInput
              source="partnerId"
              choices={partners}
              optionText={partner => `${partner.displayName || partner.name} (${partner.code})`}
              optionValue="id"
              fullWidth
              required
              label="Select Partner"
            />
          </SimpleForm>
        )}
      </Box>
    </Box>
  );
};

export default PartnerSelect;
